import React, { useState } from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import BlobButton from './BlobButton';

const portfolioItems = [
  {
    id: 1,
    image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/hr4j2zra_Fiction%20Book%20%281%29.png',
    title: 'The Picture of Dorian Gray',
    category: 'fiction',
    author: 'Oscar Wilde',
    genre: 'Fiction & Literature'
  },
  {
    id: 2,
    image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/g7ef28u2_Educational%20Book.png',
    title: 'The Quantum Screen',
    category: 'educational',
    author: 'Samuel Avery',
    genre: 'Educational & Science'
  },
  {
    id: 3,
    image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/hw7vz9yq_Fiction%20Book%20%282%29.png',
    title: 'The After House',
    category: 'fiction',
    author: 'Michael Phillip Cash',
    genre: 'Fiction & Mystery'
  },
  {
    id: 4,
    image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/zwxalo6i_romance%20%281%29.png',
    title: 'American Queen',
    category: 'romance',
    author: 'Sierra Simone',
    genre: 'Romance'
  },
  {
    id: 5,
    image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/h46wwenm_Biography%20Book.png',
    title: 'Blood & Honey',
    category: 'biography',
    author: 'Shelby Mahurin',
    genre: 'Biography & Memoir'
  },
  {
    id: 6,
    image: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/10yt2mrh_romance%20%282%29.png',
    title: 'Break the Girl',
    category: 'romance',
    author: 'Rachel Jonas & Nikki Thorne',
    genre: 'Romance'
  }
];

const categories = [
  { id: 'all', name: 'All Books' },
  { id: 'fiction', name: 'Fiction' },
  { id: 'romance', name: 'Romance' },
  { id: 'biography', name: 'Biography' },
  { id: 'educational', name: 'Educational' }
];

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredItems = activeCategory === 'all'
    ? portfolioItems
    : portfolioItems.filter(item => item.category === activeCategory);

  return (
    <section className="py-20 bg-transparent">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 border-2 border-amber-700 rounded-full mb-6">
            <span className="text-amber-700 text-sm font-semibold tracking-wider">OUR PORTFOLIO</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Featured <span className="text-amber-700">Published Works</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover some of the remarkable books that the authors have published and promoted.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map(category => (
            <Button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              variant={activeCategory === category.id ? 'default' : 'outline'}
              className={`px-8 py-6 transition-all rounded-full shadow-lg hover:shadow-xl ${
                activeCategory === category.id
                  ? 'bg-amber-700 hover:bg-amber-800 text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              {category.name}
            </Button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredItems.map((item, index) => (
            <Card
              key={item.id}
              className="group overflow-hidden shadow-2xl hover:shadow-xl transition-all duration-500 rounded-2xl"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Image Container */}
              <div className="relative h-96 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                    <p className="text-sm text-gray-300 mb-1">by {item.author}</p>
                    <p className="text-sm text-amber-400">{item.genre}</p>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Portfolio;